import React, { Component } from 'react';
import { Row, Col, Grid } from 'react-bootstrap';

import { Helmet } from "react-helmet";

import Sidebar from '../../Sidebar/Sidebar';
import Header from '../../Header/Header';
import Footer from '../../Footer/Footer';

import AgenciesContent from './AgenciesContent';
import BannerRectangleLarge from '../../Banner/BannerRectangleLarge';
import BannerRectangle from '../../Banner/BannerRectangle';

import { getLanguage } from '../../Translation/Translation'

class Agencies extends Component {
    render() {
        return (
            <div>
                <Grid fluid className="no-padding">
                    <Helmet>
                        <title>Your Agents | Openseas</title>
                    </Helmet>
                    <Row style={{ margin: '0px' }}>
                        <Col style={{ margin: '0px' }}>
                            <Header data={this.props} />

                        </Col>
                    </Row>
                    <Row style={{ margin: '0px' }}>
                        <div className="OSPageContainer">
                            <div className="OSPageContent">
                                <AgenciesContent
                                    data={this.props}
                                    agencies={this.props.data.tripAgencies}
                                    setCountry={this.props.data.setTripAgencyCountryId}
                                    setPerfecture={this.props.data.setTripAgencyPerfectureId}
                                    setMunicipality={this.props.data.setTripAgencyMunicipalityId}
                                    setAgencyList={this.props.data.setTripAgenciesList}
                                    language={getLanguage()}
                                />
                            </div>
                            <div className="OSPageSidebar">
                                <Sidebar agency="Y"/>
                            </div>
                        </div>
                    </Row>
                    <Row
                        style={{ margin: "24px 0px 24px 0" }}
                    >
                        <div className="displayBannerLarge">
                            <BannerRectangleLarge agency="Y" />
                        </div>
                    </Row>
                    <Row
                    >
                        <Col xs={12} sm={6} mdHidden lgHidden>
                            <BannerRectangle agency="Y" />
                        </Col>
                        <Col xsHidden sm={6} mdHidden lgHidden>
                            <BannerRectangle agency="Y" />
                        </Col>
                    </Row>
                    <Row style={{ margin: '0px' }}>
                        <Footer />
                    </Row>
                </Grid>
            </div>
        )
    }
}
export default Agencies


// WEBPACK FOOTER //
// ./src/components/Pages/Agencies/Agencies.js